import { get, set } from 'lodash-es';
import { useCallback, useMemo } from 'react';

import {
  Pathable,
  PathsSelectorFrom,
  pathsSelector as realizePaths,
  FormLens,
} from '@tdp/common/form';

export function useFormRevert<TSchema extends Pathable>(
  modelForm: FormLens<TSchema>,
  pathsSelector: PathsSelectorFrom<TSchema>
) {
  const paths = useMemo(() => realizePaths(pathsSelector), [pathsSelector]);
  const revert = useCallback(() => {
    modelForm.update(draft => {
      for (const path of paths) {
        if (path.length === 0) {
          return modelForm.base;
        }
        // use unknown since we assume the types at the path are the same.
        const baseValue = get(modelForm.base, path) as unknown;
        void set(draft, path, baseValue);
      }
    });
  }, [paths, modelForm])
  return revert; //const cast so typescript knows it is a tuple.
}
